module.exports = __webpack_public_path__ + "static/media/peep-start.2678cc8e.png";